import React, { useState, useEffect } from 'react';
import { SideTab } from '../Components/SideTab';
import CommissionsPanel from '../Panels/CommissionsPanel';

export default function CommissionsButton(props) {
  console.log('selected type button:', props?.selectedCommissionType);
  const [show, setShow] = useState(false);

  return (
    <>
      <div
        onClick={(e) => {
          setShow(true);
        }}
      >
        {props.buttonText}
      </div>

      <SideTab
        size="lg"
        position="right"
        title="Commission Schedules"
        onClose={(e) => setShow(false)}
        show={show}
        scroll={false}
      >
        {show && (
          <div
            style={{
              height: '100%',
              maxHeight: 'calc(100vh - 60px)', // Adjust based on your header/footer
              overflowY: 'auto',
              overflowX: 'hidden',
              paddingRight: '10px',
            }}
          >
            <CommissionsPanel
              {...props}
              showHeader={false}
              cardStyle={{ boxShadow: 'none' }}
              dispatchOnUpsert={true}
              onSave={props.onSave}
              isEmbedded={true}
              selectedCommissionType={props?.selectedCommissionType || null}
            />
          </div>
        )}
      </SideTab>
    </>
  );
}
